import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import AuthSearch from './AuthSearch';

ReactDOM.render(
  <React.StrictMode>
    <AuthSearch />
  </React.StrictMode>,
  document.getElementById('root')
);
